import { render } from "./Lojas.vue?vue&type=template&id=e9a9e4fc&scoped=true"
import script from "./Lojas.vue?vue&type=script&lang=js"
export * from "./Lojas.vue?vue&type=script&lang=js"

import "./Lojas.vue?vue&type=style&index=0&id=e9a9e4fc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\natan\\OneDrive\\Code\\Site\\dalena\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9a9e4fc"]])

export default __exports__